<template>
  <div class="shenqingkongjiandiv">
    <div class="logodiv"></div>
    <div class="applypop">
      <div class="clearfix">
        <p>人人有空间</p>
        <p>人人用空间</p>
      </div>
      <!-- <div>您可以申请以下空间</div> -->
      <!-- <div class="check_box">
                <el-checkbox-group v-model="checkAll" @change="handleCheckChange">
                    <el-checkbox @change="test(index)" v-for="(item, index) in typelist" :key="index" :label="item.space_type" border>{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="shenqingbtn" @click="establish">申请空间</div> -->
      <div style="width: 50%;margin:0 auto">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="空间类型" prop="region">
            <el-select
              v-model="ruleForm.region"
              placeholder="请选择空间类型"
              @change="getspaceval"
            >
              <el-option
                v-for="(item, index) in checkAll"
                :key="index"
                :label="item.name"
                :value="item.space_type"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级空间" prop="type" v-if="isshow">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox
                v-for="(item, index) in classlist"
                :key="index"
                :label="item.profile"
                >{{ item.profile }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="空间名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm()">立即申请</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import URL from "../../api/index";
export default {
  name: "infomalloc",
  data() {
    return {
      token: "",
      spacetype: "",
      spacename: "",
      classlist: [],
      checkAll: "",
      ruleForm: {
        name: "",
        region: "",
        type: [],
      },
      rules: {
        name: [{ required: true, message: "请输入空间名称", trigger: "blur" }],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      isshow: false,
    };
  },
  created() {
    this.getuserinfo();
    this.getspacetype();
  },
  methods: {
    getspaceval(val) {
      // console.log(val)
      if (val == "0104") {
        this.isshow = true;
        this.getmarster();
        // console.log(this.isshow)
      } else {
        this.isshow = false;
      }
    },
    submitForm(formName) {
      var formdata = {
        token: this.token,
        space_type: this.ruleForm.region,
        space_name: this.ruleForm.name,
      };

      // console.log(formdata);
      this.establish(formdata);
      // this.$refs[formName].validate((valid) => {
      // if (valid) {
      //     alert('submit!');
      // } else {
      //     console.log('error submit!!');
      //     return false;
      // }
      // });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getuserinfo() {
      this.userInfoss = JSON.parse(localStorage.getItem("info"));
      this.token = this.userInfoss.token;
      this.spacename = this.userInfoss.user_nicename + "的空间";
    },
    //获取可创建的空间
    getspacetype() {
      var that = this;
      var tokendata = { token: this.token };
      this.$post(URL.getAllowSpaceType, tokendata).then((item) => {
        that.checkAll = item.result;
        // console.log(that.ruleForm.region);
      });
    },
    //查询指定用户空间
    getmarster() {
      var that = this;
      var tokendata2 = { token: this.token };
      this.$post(URL.getMasterClass, tokendata2).then((item) => {
        that.classlist = item.result;
      });
    },
    establish(data) {
      //创建空间
      this.$post(URL.createSpace, data).then((item) => {
        if (item.state === 0) {
          let getSpaceinfo = item.result;
          localStorage.setItem("getSpaceinfo", JSON.stringify(getSpaceinfo));
          this.$router.push({
            name: "dynamic",
            query: {
              userInfo: this.userInfo,
              getSpaceinfo: this.getSpaceinfo,
              spaceid: this.Spaceid,
            },
          });
          // this.$router.go(0);
        } else {
          this.$message.error(item.msg);
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.shenqingkongjiandiv {
  width: 100%;
  height: 100%;
  position: fixed;
  top:121px;
  left: 0;
  background: url(../../assets/backimg.jpg) no-repeat center;
  background-size: 100%;

}
.shenqingbtn {
  width: 170px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  background: #2c84ff;
  margin: 150px auto;
  border-radius: 20px;
  cursor: pointer;
}
.applypop {
  width: 650px;
  height: 400px;
  border-radius: 20px;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.applypop div:nth-child(1) p {
  float: left;
  width: 50%;
  letter-spacing: 20px;
  color: #2c84ff;
  font-size: 28px;
  text-align: center;
  line-height: 150px;
}
.applypop div:nth-child(2) {
  // text-align: center;
  font-size: 16px;
  color: #3e3e3e;
}
// .logodiv {
//   width: 170px;
//   height: 42px;
//   background: url(../../assets/logo.png) no-repeat center;
//   background-size: 100%;
//   margin: 100px 0 0 130px;
// }
.check_box {
  margin: 0 auto;
}
.el-select {
  display: block !important;
}
</style>